import type { NsDict } from '../ru';

export const common: NsDict<'common'> = {
  creditsUnit: 'cr',
  'stage.prep': 'Preparation',
  'stage.round1': 'Round 1 · chart and direction',
  'stage.round2': 'Round 2 · price scale',
  'stage.round3': 'Round 3 · composition and points',
  'stage.locked': 'Waiting for the candle to close',
  'stage.settled': 'Settlement',
  'stage.cancelled': 'Cancelled',
  'action.ante': 'ante',
  'action.fold': 'fold',
  'action.check': 'check',
  'action.call': 'call',
  'action.bet': 'bet',
  'action.raise': 'raise',
  'action.raiseTo': 'raise to',
  'action.allin': 'all-in',
  auto: 'auto',
  loading: 'Loading…',
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  back: '← Back',
  forward: 'Next →',
  pages: 'Pages',
  pageOf: '{page} of {pages} · {total} total',
  never: 'never',
  justNow: 'just now',
  minutesAgo: '{n} min ago',
  hoursAgo: '{n} h ago',
  daysAgo: '{n} d ago',
  noData: 'No data yet.',
  bot: 'bot',
  botPrefix: 'Bot',
  language: 'Language',
  // ── режимы игры (0.8.0) ──
  'stageOpen.round1': 'Round 1 · direction',
  'stageOpen.round2': 'Round 2 · points',
  'stageOpen.round3': 'Round 3 · points',
};
